<template>
    <div>
<!--        :round="!this.useTo || this.useTo !== 'mini_app'"-->
        <van-popup v-model="currentShow"

                   @closed="close"
                   @opened="opened"
                   @open="open"
                   width="300px"
        >
            <div>
                <div id="capture" ref="captureDiv" :style="{width:screenWidth+'px',padding:'10px 10px 5px 10px'}">
                    <slot>


                    </slot>
                    <div>
                        <van-row style="">
                            <van-col span="17" class="info_text" style="">
                                <slot name="text"></slot>
                            </van-col>
                            <van-col span="7" class="info_scan" style="">
<!--                                <div style="width: fit-content; position: absolute; right: 12px; margin-top: 3px;">-->
<!--                                    <div id="qrCode" ref="qrCodeDiv" style="width: fit-content;"></div>-->
<!--                                </div>-->
                                <slot name="qr_top"></slot>
                                <div style="display: inline-flex; margin-top: 3px; margin-right: 8px">
                                    <div id="qrCode" ref="qrCodeDiv" style="width: fit-content;"></div>

                                    <div v-if="useJdLogo && show_jd_logo" :style="{position: 'absolute', marginTop: jd_logo_margin, marginLeft: jd_logo_margin}">
<!--                                        <div style="padding: 3px; background-color: white">-->
<!--                                            -->
<!--                                        </div>-->
                                        <img :src="jd_logo_path" :width="jd_logo_width" :height="jd_logo_width" style="border-radius: 3px;"/>

                                    </div>
                                </div>
                                <slot name="qr_bottom"></slot>
                            </van-col>
                        </van-row>
<!--                        <div style="display: table; width: 100%">-->
<!--                            <div style="text-align: left; display: table-cell; width: 70%">-->
<!--                                <slot name="text"></slot>-->
<!--                            </div>-->
<!--                            <div style="display: table-cell; background-color: #aaaaaa; vertical-align: bottom; width: 30%" >-->
<!--                                <div style="display: inline-flex; margin-right: 2px; ">-->
<!--                                    <div id="qrCode" ref="qrCodeDiv" style=""></div>-->
<!--                                </div>-->
<!--                                <slot name="qr_text"></slot>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                    <slot name="bottom">

                    </slot>
                </div>
<!--                <img v-if="dataStr" id="preview" ref="previewImg" :src="dataStr"-->
<!--                     :style="{width:screenWidth-100+'px', position: 'absolute', top: '0', left: '0'}"/>-->

                <img v-if="dataStr" id="preview" ref="previewImg" :src="dataStr"
                     :style="{width:screenWidth*0.75+'px',}"/>
            </div>

            <div class="info_tip" :style="{fontSize: tip_size, padding: tip_text_padding}">
<!--                <van-notice-bar-->
<!--                        color="#1989fa"-->
<!--                        background="#ecf9ff"-->
<!--                >-->
<!--                    {{tip_text}}-->
<!--                </van-notice-bar>-->
                {{tip_text}}
            </div>
        </van-popup>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    import html2canvas from 'html2canvas';

    export default {
        name: "Wp_share_poster",
        props: {
            shareUrl: {type: String, default: null},
            activeShow: {type: String, default: ''},
            shareImage: {type: String, default: ''},
            shareText: {type: String, default: ''},
            shareTip: {type: String, default: ''},
            width: {
                type: String,
                default: '100%'
            },
            height: {
                type: String,
                default: '100%'
            },
            bgColor: {
                type: String,
                default: '#fff'
            },
            useTo:{type: String, default: ''},
            useJdLogo: {type: Boolean, default: false},//是否使用京东logo，用于不同页面中调用Wp_share_poster时的指定
            correctLevel:{type: String, default: 'M'},
        },
        data() {
            return {
                screenWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,     // 屏幕宽
                screeHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,    // 屏幕高
                currentShow: false, //currentIndex接收父组件传来的activeIndex值；
                copyDom: null,
                dataStr: '',
                tip_text: '',
                showPop: false,
                isRound: true,

                qr_code_width: 75,
                tip_size: "14px",
                tip_text_padding: "0px",

                show_jd_logo: false,//是否显示京东logo，用于区分小程序二维码和普通二维码，普通二维码显示
                jd_logo_margin: '25px',//京东logo距离左边（顶部）的距离
                jd_logo_width: '15px',//京东logo的宽度
                jd_logo_path: '/images/jd_logo.png',

                correct_level: 'M',
            }
        },
        created(){
            // alert(this.screenWidth)
            let temp_qr_width = (this.screenWidth - 10) / 24 * 7 * 0.9;
            if(this.qr_code_width > temp_qr_width){
                this.qr_code_width = temp_qr_width;
            }

            this.initQr_code();

        },

        mounted() {

        },
        watch: {
            activeShow(val) {
                // this.$log("activeShow111 = " + val)
                // setTimeout(()=>{
                //     this.currentShow = true;
                // }, 500)
                if(this.shareUrl){
                    this.currentShow = true;
                }else{
                    this.$dialog.alert({
                        message: "海报制作异常，请重试"
                    })
                }
            },
            useTo(newValue){
                this.$log("userTo = " + newValue);
                this.initQr_code();
                // if(this.$common.hasWxUserInfo_mini() || this.$common.hasWxUserInfo_public()){
                //     this.qr_code_width = 90;
                //     this.jd_logo_margin = '34px';
                //     this.jd_logo_width = '22px'
                // }else{
                //     if(newValue === 'mini_app'){
                //         this.qr_code_width = 80;
                //         this.jd_logo_margin = '31px';
                //         this.jd_logo_width = '20px'
                //     }else{
                //         this.qr_code_width = 75;
                //         this.jd_logo_margin = '28px';
                //         this.jd_logo_width = '20px'
                //     }
                // }
            }
        },
        methods: {
            initQr_code(){
                // if(this.$common.hasWxUserInfo_mini() || this.$common.hasWxUserInfo_public()){
                if(this.$common.hasWxUserInfo_mini()){
                    this.qr_code_width = 90;
                    this.jd_logo_margin = '33px';
                    this.jd_logo_width = '24px'
                }else{
                    if(this.useTo === 'mini_app'){
                        this.qr_code_width = 80;
                        this.jd_logo_margin = '31px';
                        this.jd_logo_width = '20px'
                    }else{
                        this.qr_code_width = 75;
                        this.jd_logo_margin = '28px';
                        this.jd_logo_width = '20px'
                    }
                }
            },
            close() {
                let qrCode = this.$refs.qrCodeDiv;
                this.resetChilds(qrCode);

                // if(this.copyDom){
                //     this.resetChilds(this.copyDom);
                // }

                this.$emit('onClose', false);

            },
            open() {
                this.dataStr = "";
                this.tip_text = "";
                this.tip_text_padding = "0px";
            },
            opened() {
                this.dataStr = "";//'_' + Date.parse(new Date());
                this.copyDom = this.$refs.captureDiv;  //弹窗中一定要用这种方式获取
                setTimeout(() => {
                    if(this.useTo && this.useTo === "mini_app"){
                        this.isRound = false;
                        this.show_jd_logo = false;
                        this.getMiniAppQR();
                    }else{
                        this.show_jd_logo = true;
                        this.getQR();
                    }

                }, 10);

            },
            getQR() {
                this.copyDom.hidden = false;
                this.tip_text = '开始生成二维码';
                let that = this;
                if (that.shareUrl) {
                    let qrCode = this.$refs.qrCodeDiv;
                    if (qrCode) {
                        this.resetChilds(qrCode);

                        // if(this.useTo === 'mini_app'){
                        //     this.qr_code_width = 80;
                        // }
                        if(this.correctLevel === 'L'){
                            this.correct_level = QRCode.CorrectLevel.L;
                        }else if(this.correctLevel === 'M'){
                            this.correct_level = QRCode.CorrectLevel.M;
                        }else if(this.correctLevel === 'Q'){
                            this.correct_level = QRCode.CorrectLevel.Q;
                        }else if(this.correctLevel === 'H'){
                            this.correct_level = QRCode.CorrectLevel.H;
                        }else{
                            this.correct_level = QRCode.CorrectLevel.M;
                        }

                        this.$log("this.correct_level = " + this.correct_level)
                        let qrMaker = new QRCode(qrCode, {
                            width: this.qr_code_width,
                            height: this.qr_code_width,
                            colorDark: "#333333", //二维码颜色
                            colorLight: "#ffffff", //二维码背景色
                            correctLevel: this.correct_level//容错率，L/M/Q/H
                        });
                        qrMaker.clear(); //清除二维码
                        qrMaker.makeCode(this.shareUrl); //生成另一个新的二维码

                        this.tip_text = '二维码生成完成';
                        this.html2Img();
                    }
                }
            },
            html2Img() {
                let scroll_1 = document.documentElement.scrollTop;
                let scroll_2 = window.pageYOffset;
                let scroll_3 = document.body.scrollTop;
                this.tip_text = '开始生成海报';
                this.tip_text_padding = "10px";
                document.documentElement.scrollTop = 0;
                window.pageYOffset = 0;
                document.body.scrollTop = 0;

                setTimeout(()=>{
                    // this.copyDom.style.width = this.screenWidth+"px";
                    html2canvas(this.copyDom, {
                        removeContainer: false,
                        allowTaint: true, //允许污染
                        taintTest: true, //在渲染前测试图片(没整明白有啥用)
                        useCORS: true, //使用跨域(当allowTaint为true时这段代码没什么用)
                        background: "#fff",
                        onclone(doc) {
                            let e = doc.querySelector('#capture');
                            e.style.display = 'block'
                        }
                    }).then(canvas=> {
                        this.copyDom.hidden = true;

                        let imgData = canvas.toDataURL();
                        this.dataStr = imgData;

                        this.tip_text = '海报已生成,请长按图片保存或直接分享';

                        document.documentElement.scrollTop = scroll_1;
                        window.pageYOffset = scroll_2;
                        document.body.scrollTop = scroll_3;
                    });
                }, 500)

            },

            resetChilds(parent) {
                let child = parent.lastElementChild;
                while (child) {
                    parent.removeChild(child);
                    child = parent.lastElementChild;
                }
            },

            /**
             * 使用小程序的二维码进行构图
             */
            getMiniAppQR(){
                this.copyDom.hidden = false;
                this.tip_text = '开始生成二维码';
                let qrCode = this.$refs.qrCodeDiv;
                this.resetChilds(qrCode);

                let img = new Image();
                img.width = this.qr_code_width;
                img.height = this.qr_code_width;
                if(this.shareUrl){
                    img.onload = () => {
                        qrCode.appendChild(img);
                        this.tip_text = '二维码生成完成';
                        this.html2Img();
                    };
                    img.src = this.shareUrl;
                }else{
                    this.getWxAppQrcode(qr_url =>{
                        this.$log(qr_url)
                        img.onload = () => {
                            qrCode.appendChild(img);
                            this.tip_text = '二维码生成完成';
                            this.html2Img();
                        };
                        img.src = qr_url;
                    })
                }
            },

            /**
             * 获取小程序的二维码
             */
            getWxAppQrcode(fn){
                if(this.$common.gloabl_wx_mini_user_info){
                    let u_code = this.$common.gloabl_wx_mini_user_info.u_code;
                    let params = {
                        app_id: this.$common.wx_app_id,
                        app_secret: this.$common.wx_app_secret,
                        scene: u_code,
                        width: 300
                    };

                    this.$getWxAppQrcode(params, response =>{
                        // this.$log(response.data)
                        // alert(response.data)
                        if(fn){
                            fn(response.data)
                        }
                    })
                }

            }
        }
    }
</script>

<style scoped>
    .info_text {
        text-align: left;
        padding-left: 0px;
        font-size: 15px;
        font-weight: bold;
    }

    .info_scan {
        text-align: right;
        font-size: 8px
    }

    .info_tip {
        text-align: center;
        /*margin-top: 10px;*/
        /*display: inline;*/
        color: #1989fa;
        background-color: #ecf9ff;
    }
</style>